import request from '@/utils/request'

// 查询订单列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/order/page',
        method: 'get',
        params: query,
    })
}
// 查询订单详细
export function getObj(id) {
    return request({
        url: '/upkeep/order/detail?id=' + id,
        method: 'get',
    })
}
// 新增订单
export function addObj(data) {
    return request({
        url: '/upkeep/script/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用 维修首页状态
export function statusObj(data) {
    return request({
        url: '/upkeep/script/status',
        method: 'post',
        data: data,
    })
}
// 抢单
export function putObj(data) {
    return request({
        url: '/upkeep/order/rob',
        method: 'post',
        data: data,
    })
}
// // 抢单池
// export function putObj(data) {
//     return request({
//         url: '/upkeep/order/rob',
//         method: 'post',
//         data: data
//     })
// }
// 删除订单
export function delObj(data) {
    return request({
        url: '/upkeep/order/delete',
        method: 'post',
        data: data,
    })
}

export function fetchDetail(data) {
    return request({
        url: '/upkeep/order/detail',
        method: 'post',
        data: data,
    })
}
